import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

import logoLight from "../../assets/images/nextskillAI_light.WebP";
import logoDark from "../../assets/images/nextskillAI_dark.WebP";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/tutorials", label: "Tutorials" },
  { to: "/about", label: "About" },
];

function Navbar({ theme = "dark", setTheme }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  /* SCROLL EFFECT */
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* CLOSE MENU ON ROUTE CHANGE */
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  /* ACTIVE LINK */
  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">

          {/* LOGO */}
          <Link to="/" className="logo">
            <img
              src={theme === "dark" ? logoDark : logoLight}
              alt="NextSkillAI"
              className="logo-image"
            />
          </Link>

          {/* DESKTOP LINKS */}
          <ul className="nav-links">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={isActive(to) ? "active-link" : ""}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          {/* RIGHT SIDE */}
          <div className="nav-actions">

            {/* THEME TOGGLE */}
            <button
              className="theme-toggle"
              onClick={() =>
                setTheme(theme === "dark" ? "light" : "dark")
              }
              aria-label="Toggle Theme"
            >
              {theme === "dark" ? "☀️" : "🌙"}
            </button>

            {/* DISABLED LOGIN BUTTON */}
            <button
              className="login-link"
              disabled
              style={{ opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }}
            >
              Login
            </button>

            {/* DISABLED GET STARTED BUTTON */}
            <button
              className="btn-signup"
              disabled
              style={{ opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }}
            >
              Get Started
            </button>

          </div>

          {/* MOBILE BUTTON */}
          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>

        </div>
      </nav>

      {/* BACKDROP */}
      {menuOpen && (
        <div
          className="drawer-backdrop"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* MOBILE DRAWER */}
      <div className={`mobile-drawer ${menuOpen ? "active" : ""}`}>
        <div className="drawer-inner">

          <ul className="mobile-links">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>

          <div className="drawer-actions">
            {/* DISABLED LOGIN IN MOBILE */}
            <button
              className="drawer-login"
              disabled
              style={{ opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }}
            >
              Login
            </button>

            {/* DISABLED GET STARTED IN MOBILE */}
            <button
              className="drawer-signup"
              disabled
              style={{ opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }}
            >
              Get Started
            </button>

            {/* THEME IN MOBILE */}
            <button
              onClick={() =>
                setTheme(theme === "dark" ? "light" : "dark")
              }
            >
              Toggle Theme
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default Navbar;